export type PlaybackFailureKind = 'blocked' | 'aborted' | 'unsupported' | 'unknown'

export interface PlaybackRequestGuard {
  begin(): number
  invalidate(): void
  isCurrent(requestId: number): boolean
}

function errorName(error: unknown): string {
  if (error instanceof DOMException) return error.name
  if (typeof error !== 'object' || error === null || !('name' in error)) return ''
  return typeof error.name === 'string' ? error.name : ''
}

export function classifyPlaybackFailure(error: unknown): PlaybackFailureKind {
  switch (errorName(error)) {
    case 'NotAllowedError':
      return 'blocked'
    case 'AbortError':
      return 'aborted'
    case 'NotSupportedError':
      return 'unsupported'
    default:
      return 'unknown'
  }
}

export function createPlaybackRequestGuard(): PlaybackRequestGuard {
  let currentRequestId = 0
  return {
    begin() {
      currentRequestId += 1
      return currentRequestId
    },
    invalidate() {
      currentRequestId += 1
    },
    isCurrent(requestId) {
      return requestId === currentRequestId
    },
  }
}
